import { Schema } from '../../../../../adapters/schema';
import getFormErrors from '../../../../../utils/translations/formErrors.translations';
import { getTranslation } from '../../../../../utils/translations';
import translations from './translations';
import { asTypeProxy, makePathModel, } from '../../../../../utils/nestedPathModel';
import { phoneUtils } from '../../../../../utils/phone.utils';
var t = getTranslation(translations);
var initialValues = {};
var fields = asTypeProxy();
var PATHS = {
    SALUTATION: fields.salutation,
    FIRSTNAME: fields.firstName,
    LASTNAME: fields.lastName,
    DATE_OF_BIRTH: fields.dateOfBirth,
    EMAIL: fields.contact1.emailAddress,
    PHONE_NUMBER: fields.contact2.number,
    IS_SECOND_APPLICANT: fields.isSecondApplicant,
};
var paths = makePathModel(PATHS)[0];
function getNameStringSchema(label) {
    return Schema.string()
        .label(label)
        .trim()
        .required()
        .min(2)
        .max(50)
        .matches(/^([^0-9]*)$/, getFormErrors(label).notNumbers)
        .test(label, getFormErrors(label).notSpecialCharactersForNames, function (value) {
        return (!value || !/([^a-zA-Z0-9äöüÄÖÜß \.\-]|[\-]{2}|[\.]{2})/.test(value));
    });
}
var validationSchema = Schema.object({
    salutation: Schema.string().label(t.salutation).required(),
    firstName: getNameStringSchema(t.firstName),
    lastName: getNameStringSchema(t.surname),
    dateOfBirth: Schema.date().label(t.dateOfBirth).required(),
    contact1: Schema.object({
        emailAddress: Schema.string()
            .label(t.email)
            .trim()
            .required()
            .email()
            .max(50),
    }),
    contact2: Schema.object().when('isSecondApplicant', {
        is: false,
        then: function (schema) {
            return schema.shape({
                number: Schema.string()
                    .label(t.phone)
                    .trim()
                    .required(getFormErrors().phoneIsNotValid)
                    .test(t.phone, getFormErrors().phoneIsNotValid, phoneUtils.isValid),
            });
        },
    }),
});
export var applicantSubformModel = {
    paths: paths,
    initialValues: initialValues,
    validationSchema: validationSchema,
};
